var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenstra17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 420,
    viewBox: "0 0 1920 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 1920,
    height: 420,
    transform: "translate(0 11619)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    transform: "translate(0 -11619)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2381",
    "data-name": "Group 2381",
    transform: "translate(-96.37 12065.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(1654.459 -419.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M1223.452-130.781V-422.462c0-.25.608-.453,1.36-.453s1.36.2,1.36.453v291.681c0,.249-.608.452-1.36.452S1223.452-130.532,1223.452-130.781Z",
    transform: "translate(-1223.452 422.915)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(1707.966 -356.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M1262.785-147.448V-376.212c0-.25.608-.453,1.36-.453s1.36.2,1.36.453v228.764c0,.249-.608.452-1.36.452S1262.785-147.2,1262.785-147.448Z",
    transform: "translate(-1262.785 376.665)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(1654.607 -199.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M1277.721-208.218l-54.1-51.223c-.181-.17.091-.75.609-1.3s1.08-.849,1.26-.68l54.107,51.223c.178.17-.094.748-.611,1.3S1277.9-208.048,1277.721-208.218Z",
    transform: "translate(-1223.561 261.462)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M1225.487-208.218l54.1-51.223c.181-.17-.091-.75-.609-1.3s-1.08-.849-1.26-.68l-54.107,51.223c-.178.17.094.748.611,1.3S1225.306-208.048,1225.487-208.218Z",
    transform: "translate(-1223.561 261.462)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(1654.607 -251.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M1277.721-246.468l-54.1-51.223c-.181-.17.091-.75.609-1.3s1.08-.849,1.26-.68l54.107,51.223c.178.17-.094.748-.611,1.3S1277.9-246.3,1277.721-246.468Z",
    transform: "translate(-1223.561 299.712)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M1225.487-246.468l54.1-51.223c.181-.17-.091-.75-.609-1.3s-1.08-.849-1.26-.68l-54.107,51.223c-.178.17.094.748.611,1.3S1225.306-246.3,1225.487-246.468Z",
    transform: "translate(-1223.561 299.712)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(1654.607 -303.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M1277.721-284.468l-54.1-51.223c-.181-.17.091-.75.609-1.3s1.08-.849,1.26-.68l54.107,51.223c.178.17-.094.748-.611,1.3S1277.9-284.3,1277.721-284.468Z",
    transform: "translate(-1223.561 337.712)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M1225.487-284.468l54.1-51.223c.181-.17-.091-.75-.609-1.3s-1.08-.849-1.26-.68l-54.107,51.223c-.178.17.094.748.611,1.3S1225.306-284.3,1225.487-284.468Z",
    transform: "translate(-1223.561 337.712)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280",
    transform: "translate(1654.607 -355.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M1277.721-322.968l-54.1-51.223c-.181-.17.091-.75.609-1.3s1.08-.849,1.26-.68l54.107,51.223c.178.17-.094.748-.611,1.3S1277.9-322.8,1277.721-322.968Z",
    transform: "translate(-1223.561 376.212)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M1225.487-322.968l54.1-51.223c.181-.17-.091-.75-.609-1.3s-1.08-.849-1.26-.68l-54.107,51.223c-.178.17.094.748.611,1.3S1225.306-322.8,1225.487-322.968Z",
    transform: "translate(-1223.561 376.212)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(983.328 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M1043.93-199.65h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1043.93-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1036.689-199.65Zm-7.239,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1029.45-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1022.213-199.65Zm-7.237,0h-1.211a1.353,1.353,0,0,1-1.358-1.358,1.354,1.354,0,0,1,1.358-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,1014.976-199.65Zm-7.238,0h-1.211a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1007.738-199.65Zm-7.241,0h-1.208a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.358,1.358,0,0,1,1.362,1.356A1.356,1.356,0,0,1,1000.5-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,993.257-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,986.018-199.65Zm-7.237,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,978.781-199.65Zm-7.238,0h-1.211a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,971.543-199.65Zm-7.237,0H963.1a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,964.306-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.362-1.358,1.358,1.358,0,0,1,1.362-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,957.065-199.65Zm-7.237,0H948.62a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,949.828-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.355-1.358,1.355,1.355,0,0,1,1.355-1.356h1.208a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,942.586-199.65Zm-7.238,0h-1.207a1.353,1.353,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,935.348-199.65Zm-7.236,0H926.9a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.209a1.356,1.356,0,0,1,1.356,1.356A1.355,1.355,0,0,1,928.112-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.208a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,920.871-199.65Zm-7.234,0h-1.211a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,913.637-199.65Zm-7.242,0h-1.205a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,906.394-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,899.155-199.65Zm-7.237,0H890.71a1.357,1.357,0,0,1-1.359-1.358,1.359,1.359,0,0,1,1.359-1.356h1.208a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,891.918-199.65Zm-7.238,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.356,1.356A1.355,1.355,0,0,1,884.679-199.65Zm-7.237,0H876.23a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,877.442-199.65Zm-7.241,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356H870.2a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,870.2-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.36,1.36,0,0,1,862.961-199.65Zm-7.24,0h-1.2a1.358,1.358,0,0,1-1.362-1.358,1.359,1.359,0,0,1,1.362-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,855.721-199.65Zm-7.237,0h-1.207a1.358,1.358,0,0,1-1.36-1.358,1.359,1.359,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,848.484-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,841.247-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,834.006-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,826.766-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,819.529-199.65Zm-7.238,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.359,1.359,0,0,1,1.362,1.356A1.358,1.358,0,0,1,812.291-199.65Zm-7.24,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,805.051-199.65Zm-7.236,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,797.815-199.65Zm-7.238,0h-1.209a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,790.577-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,783.336-199.65Zm-7.24,0h-1.205a1.354,1.354,0,0,1-1.356-1.358,1.356,1.356,0,0,1,1.356-1.356H776.1a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,776.1-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.359-1.358,1.356,1.356,0,0,1,1.359-1.356h1.205a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,768.859-199.65Zm-7.238,0h-1.2a1.359,1.359,0,0,1-1.365-1.358,1.36,1.36,0,0,1,1.365-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,761.621-199.65Zm-7.238,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,754.382-199.65Zm-7.236,0h-1.212a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.212a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,747.146-199.65Zm-7.241,0H738.7a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.208a1.36,1.36,0,0,1,1.359,1.356A1.358,1.358,0,0,1,739.905-199.65Zm-7.242,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,732.663-199.65Z",
    transform: "translate(-730.1 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(664.549 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M809.594-199.65h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,809.594-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,802.353-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,795.114-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,787.877-199.65Zm-7.237,0h-1.211a1.353,1.353,0,0,1-1.358-1.358,1.354,1.354,0,0,1,1.358-1.356h1.211A1.358,1.358,0,0,1,782-201.008,1.357,1.357,0,0,1,780.64-199.65Zm-7.238,0h-1.211a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356H773.4a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,773.4-199.65Zm-7.241,0h-1.208a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.358,1.358,0,0,1,1.362,1.356A1.356,1.356,0,0,1,766.161-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,758.921-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,751.682-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,744.445-199.65Zm-7.238,0H736a1.353,1.353,0,0,1-1.356-1.358A1.355,1.355,0,0,1,736-202.364h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,737.207-199.65Zm-7.237,0H728.76a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,729.97-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.362-1.358,1.358,1.358,0,0,1,1.362-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,722.729-199.65Zm-7.237,0h-1.208a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,715.492-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.355-1.358,1.355,1.355,0,0,1,1.355-1.356h1.208a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,708.25-199.65Zm-7.237,0h-1.208a1.353,1.353,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.208a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,701.013-199.65Zm-7.237,0h-1.209a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.209a1.356,1.356,0,0,1,1.356,1.356A1.355,1.355,0,0,1,693.776-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.208a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,686.535-199.65Zm-7.234,0H678.09a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356H679.3a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,679.3-199.65Zm-7.242,0h-1.205a1.359,1.359,0,0,1-1.365-1.358,1.361,1.361,0,0,1,1.365-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,672.058-199.65Zm-7.24,0h-1.205a1.357,1.357,0,0,1-1.359-1.358,1.358,1.358,0,0,1,1.359-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,664.819-199.65Zm-7.237,0h-1.208a1.357,1.357,0,0,1-1.359-1.358,1.359,1.359,0,0,1,1.359-1.356h1.208a1.356,1.356,0,0,1,1.358,1.356A1.355,1.355,0,0,1,657.582-199.65Zm-7.238,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.358,1.358,0,0,1,1.358,1.356A1.356,1.356,0,0,1,650.343-199.65Zm-7.237,0h-1.212a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,643.106-199.65Zm-7.241,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,635.865-199.65Zm-7.24,0H627.42a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.36,1.36,0,0,1,628.625-199.65Zm-7.24,0h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,621.385-199.65Zm-7.237,0h-1.207a1.359,1.359,0,0,1-1.36-1.358,1.36,1.36,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,614.148-199.65Zm-7.237,0H605.7a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,606.911-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,599.67-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,592.43-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,585.193-199.65Zm-7.239,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,577.955-199.65Zm-7.24,0H569.51a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,570.715-199.65Zm-7.236,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,563.479-199.65Zm-7.238,0h-1.209a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,556.241-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356H549a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,549-199.65Zm-7.24,0h-1.205a1.354,1.354,0,0,1-1.356-1.358,1.356,1.356,0,0,1,1.356-1.356h1.205a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,541.76-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.359-1.358,1.356,1.356,0,0,1,1.359-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,534.523-199.65Zm-7.238,0h-1.2a1.359,1.359,0,0,1-1.365-1.358,1.36,1.36,0,0,1,1.365-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,527.285-199.65Zm-7.238,0H518.84a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,520.046-199.65Zm-7.236,0H511.6a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.212a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,512.811-199.65Zm-7.241,0h-1.208a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.208a1.36,1.36,0,0,1,1.359,1.356A1.358,1.358,0,0,1,505.569-199.65Zm-7.242,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,498.327-199.65Z",
    transform: "translate(-495.764 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(345.773 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M575.26-199.65h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,575.26-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,568.019-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,560.78-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,553.543-199.65Zm-7.237,0H545.1a1.353,1.353,0,0,1-1.358-1.358,1.354,1.354,0,0,1,1.358-1.356h1.211a1.358,1.358,0,0,1,1.356,1.356A1.357,1.357,0,0,1,546.306-199.65Zm-7.238,0h-1.211a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,539.068-199.65Zm-7.241,0h-1.208a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.358,1.358,0,0,1,1.362,1.356A1.356,1.356,0,0,1,531.827-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,524.587-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,517.348-199.65Zm-7.237,0H508.9a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,510.111-199.65Zm-7.238,0h-1.211a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,502.873-199.65Zm-7.237,0h-1.209a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,495.636-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.362-1.358,1.358,1.358,0,0,1,1.362-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,488.395-199.65Zm-7.237,0H479.95a1.359,1.359,0,0,1-1.363-1.358,1.361,1.361,0,0,1,1.363-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,481.158-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.355-1.358,1.355,1.355,0,0,1,1.355-1.356h1.208a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,473.917-199.65Zm-7.237,0h-1.208a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.208a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,466.679-199.65Zm-7.237,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.356,1.356A1.355,1.355,0,0,1,459.442-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.358-1.358,1.356,1.356,0,0,1,1.358-1.356H452.2a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,452.2-199.65Zm-7.234,0h-1.211a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,444.967-199.65Zm-7.242,0h-1.205a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,437.724-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.358,1.358,0,0,1,1.359-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,430.485-199.65Zm-7.237,0H422.04a1.357,1.357,0,0,1-1.359-1.358,1.359,1.359,0,0,1,1.359-1.356h1.208a1.356,1.356,0,0,1,1.358,1.356A1.355,1.355,0,0,1,423.248-199.65Zm-7.238,0H414.8a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.358,1.358,0,0,1,1.358,1.356A1.356,1.356,0,0,1,416.009-199.65Zm-7.237,0h-1.211a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.211a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,408.772-199.65Zm-7.241,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,401.531-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.36,1.36,0,0,1,394.291-199.65Zm-7.24,0h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,387.051-199.65Zm-7.237,0h-1.207a1.359,1.359,0,0,1-1.36-1.358,1.36,1.36,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,379.814-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,372.577-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,365.336-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356H358.1a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,358.1-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,350.859-199.65Zm-7.238,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,343.621-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,336.381-199.65Zm-7.236,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,329.145-199.65Zm-7.238,0H320.7a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,321.907-199.65Zm-7.241,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,314.666-199.65Zm-7.24,0h-1.205a1.354,1.354,0,0,1-1.356-1.358,1.356,1.356,0,0,1,1.356-1.356h1.205a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,307.426-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.359-1.358,1.356,1.356,0,0,1,1.359-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,300.189-199.65Zm-7.237,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,292.952-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,285.712-199.65Zm-7.236,0h-1.212a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.212a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,278.477-199.65Zm-7.241,0h-1.208a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.208a1.36,1.36,0,0,1,1.359,1.356A1.358,1.358,0,0,1,271.235-199.65Zm-7.242,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,263.993-199.65Z",
    transform: "translate(-261.43 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    transform: "translate(27.37 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M341.2-199.65h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356H341.2a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,341.2-199.65Zm-7.241,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,333.959-199.65Zm-7.237,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,326.722-199.65Zm-7.238,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,319.483-199.65Zm-7.237,0h-1.211a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.211a1.358,1.358,0,0,1,1.356,1.356A1.357,1.357,0,0,1,312.246-199.65Zm-7.237,0H303.8a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.212a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,305.009-199.65Zm-7.241,0H296.56a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.208a1.359,1.359,0,0,1,1.362,1.356A1.357,1.357,0,0,1,297.768-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,290.527-199.65Zm-7.238,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.354,1.354,0,0,1,1.358,1.356A1.353,1.353,0,0,1,283.288-199.65Zm-7.236,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,276.053-199.65Zm-7.24,0H267.6a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.209a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,268.813-199.65Zm-7.237,0h-1.209a1.354,1.354,0,0,1-1.358-1.358,1.356,1.356,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.357,1.357,0,0,1,261.576-199.65Zm-7.24,0h-1.207a1.356,1.356,0,0,1-1.362-1.358,1.358,1.358,0,0,1,1.362-1.356h1.207a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,254.336-199.65Zm-7.237,0h-1.208a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356H247.1a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,247.1-199.65Zm-7.242,0H238.65a1.355,1.355,0,0,1-1.356-1.358,1.356,1.356,0,0,1,1.356-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,239.857-199.65Zm-7.237,0h-1.208a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.208a1.354,1.354,0,0,1,1.356,1.356A1.352,1.352,0,0,1,232.619-199.65Zm-7.236,0h-1.209a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.209a1.357,1.357,0,0,1,1.356,1.356A1.356,1.356,0,0,1,225.384-199.65Zm-7.243,0h-1.207a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.207a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,218.141-199.65Zm-7.234,0H209.7a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.211a1.358,1.358,0,0,1,1.356,1.356A1.357,1.357,0,0,1,210.907-199.65Zm-7.241,0h-1.207a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,203.666-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.205a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,196.426-199.65Zm-7.238,0H187.98a1.358,1.358,0,0,1-1.359-1.358,1.36,1.36,0,0,1,1.359-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,189.188-199.65Zm-7.237,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.356,1.356A1.355,1.355,0,0,1,181.951-199.65Zm-7.237,0H173.5a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.355,1.355,0,0,1,174.713-199.65Zm-7.242,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,167.471-199.65Zm-7.24,0h-1.205a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,160.231-199.65Zm-7.238,0h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,152.993-199.65Zm-7.238,0h-1.205a1.358,1.358,0,0,1-1.36-1.358,1.359,1.359,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,145.754-199.65Zm-7.237,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,138.517-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.205a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,131.278-199.65Zm-7.24,0h-1.205a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.36,1.36,0,0,1,124.038-199.65Zm-7.238,0h-1.2a1.355,1.355,0,0,1-1.36-1.358,1.356,1.356,0,0,1,1.36-1.356h1.2a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,116.8-199.65Zm-7.238,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,109.561-199.65Zm-7.238,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,102.323-199.65Zm-7.237,0H93.879a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.358,1.358,0,0,1,1.359,1.356A1.357,1.357,0,0,1,95.085-199.65Zm-7.238,0H86.639a1.357,1.357,0,0,1-1.359-1.358,1.358,1.358,0,0,1,1.359-1.356h1.208a1.359,1.359,0,0,1,1.358,1.356A1.357,1.357,0,0,1,87.847-199.65Zm-7.24,0H79.4a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,80.607-199.65Zm-7.24,0H72.162a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,73.367-199.65Zm-7.238,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,66.129-199.65Zm-7.237,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,58.892-199.65Zm-7.238,0H50.447a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.358,1.358,0,0,1,1.358,1.356A1.356,1.356,0,0,1,51.654-199.65Zm-7.237,0H43.206a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,44.417-199.65Zm-7.241,0H35.967a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.208a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,37.175-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,29.934-199.65Z",
    transform: "translate(-27.37 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(1303.089 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M1286.226-199.65h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.359,1.356A1.356,1.356,0,0,1,1286.226-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1278.985-199.65Zm-7.238,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1271.747-199.65Zm-7.237,0H1263.3a1.355,1.355,0,0,1-1.36-1.358,1.356,1.356,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1264.51-199.65Zm-7.237,0h-1.211a1.353,1.353,0,0,1-1.358-1.358,1.354,1.354,0,0,1,1.358-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,1257.272-199.65Zm-7.238,0h-1.211a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1250.034-199.65Zm-7.241,0h-1.208a1.359,1.359,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.208a1.358,1.358,0,0,1,1.362,1.356A1.356,1.356,0,0,1,1242.793-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.359,1.356A1.356,1.356,0,0,1,1235.553-199.65Zm-7.24,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.359,1.356A1.354,1.354,0,0,1,1228.313-199.65Zm-7.236,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.355,1.355,0,0,1,1.356,1.356A1.353,1.353,0,0,1,1221.078-199.65Zm-7.239,0h-1.211a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.211a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1213.839-199.65Zm-7.237,0h-1.209a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.357,1.356A1.358,1.358,0,0,1,1206.6-199.65Zm-7.241,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1199.361-199.65Zm-7.237,0h-1.208a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1192.124-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.355-1.358,1.355,1.355,0,0,1,1.355-1.356h1.208a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1184.883-199.65Zm-7.238,0h-1.207a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.207a1.354,1.354,0,0,1,1.356,1.356A1.352,1.352,0,0,1,1177.645-199.65Zm-7.236,0H1169.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.209a1.356,1.356,0,0,1,1.356,1.356A1.355,1.355,0,0,1,1170.409-199.65Zm-7.241,0h-1.208a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.208a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,1163.168-199.65Zm-7.236,0h-1.209a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,1155.932-199.65Zm-7.241,0h-1.205a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1148.691-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.358,1.358,0,0,1,1.359-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1141.451-199.65Zm-7.237,0h-1.208a1.357,1.357,0,0,1-1.359-1.358,1.359,1.359,0,0,1,1.359-1.356h1.208a1.356,1.356,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1134.214-199.65Zm-7.239,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.356,1.356A1.355,1.355,0,0,1,1126.975-199.65Zm-7.237,0h-1.212a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,1119.739-199.65Zm-7.241,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,1112.5-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,1105.258-199.65Zm-7.24,0h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1098.018-199.65Zm-7.237,0h-1.207a1.358,1.358,0,0,1-1.36-1.358,1.359,1.359,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1090.781-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1083.544-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1076.3-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1069.063-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1061.826-199.65Zm-7.24,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,1054.586-199.65Zm-7.238,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,1047.348-199.65Zm-7.236,0H1038.9a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1040.112-199.65Zm-7.24,0h-1.208a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.208a1.36,1.36,0,0,1,1.359,1.356A1.358,1.358,0,0,1,1032.872-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1025.632-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,1018.393-199.65Zm-7.237,0h-1.205a1.355,1.355,0,0,1-1.359-1.358,1.356,1.356,0,0,1,1.359-1.356h1.205a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1011.155-199.65Zm-7.238,0h-1.2a1.358,1.358,0,0,1-1.364-1.358,1.36,1.36,0,0,1,1.364-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1003.917-199.65Zm-7.239,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,996.679-199.65Zm-7.236,0h-1.212a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.212a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,989.443-199.65Zm-7.243,0h-1.207a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356H982.2a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,982.2-199.65Zm-7.241,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,974.959-199.65Zm-7.237,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,967.722-199.65Z",
    transform: "translate(-965.158 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286",
    transform: "translate(1787.174 -119.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M1642.079-199.65h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1642.079-199.65Zm-7.241,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1634.838-199.65Zm-7.237,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1627.6-199.65Zm-7.239,0h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.356,1.356,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1620.362-199.65Zm-7.237,0h-1.211a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.211a1.358,1.358,0,0,1,1.356,1.356A1.357,1.357,0,0,1,1613.125-199.65Zm-7.237,0h-1.212a1.353,1.353,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.212a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1605.888-199.65Zm-7.241,0h-1.208a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.208a1.358,1.358,0,0,1,1.362,1.356A1.357,1.357,0,0,1,1598.647-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1591.406-199.65Zm-7.239,0h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.354,1.354,0,0,1,1.358,1.356A1.353,1.353,0,0,1,1584.167-199.65Zm-7.236,0h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,1576.932-199.65Zm-7.24,0h-1.209a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.209a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1569.692-199.65Zm-7.237,0h-1.209a1.355,1.355,0,0,1-1.358-1.358,1.356,1.356,0,0,1,1.358-1.356h1.209a1.358,1.358,0,0,1,1.358,1.356A1.357,1.357,0,0,1,1562.455-199.65Zm-7.24,0h-1.207a1.356,1.356,0,0,1-1.362-1.358,1.358,1.358,0,0,1,1.362-1.356h1.207a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1555.215-199.65Zm-7.239,0h-1.207a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.207a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1547.977-199.65Zm-7.241,0h-1.207a1.355,1.355,0,0,1-1.356-1.358,1.357,1.357,0,0,1,1.356-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1540.736-199.65Zm-7.237,0h-1.208a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.208a1.354,1.354,0,0,1,1.356,1.356A1.352,1.352,0,0,1,1533.5-199.65Zm-7.236,0h-1.209a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.209a1.357,1.357,0,0,1,1.356,1.356A1.356,1.356,0,0,1,1526.263-199.65Zm-7.242,0h-1.207a1.354,1.354,0,0,1-1.358-1.358,1.355,1.355,0,0,1,1.358-1.356h1.207a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,1519.02-199.65Zm-7.234,0h-1.211a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.211a1.358,1.358,0,0,1,1.356,1.356A1.357,1.357,0,0,1,1511.786-199.65Zm-7.241,0h-1.207a1.359,1.359,0,0,1-1.365-1.358,1.361,1.361,0,0,1,1.365-1.356h1.207a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1504.545-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1497.3-199.65Zm-7.237,0h-1.208a1.358,1.358,0,0,1-1.359-1.358,1.36,1.36,0,0,1,1.359-1.356h1.208a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1490.067-199.65Zm-7.237,0h-1.208a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.356,1.356A1.355,1.355,0,0,1,1482.83-199.65Zm-7.237,0h-1.212a1.353,1.353,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.355,1.355,0,0,1,1475.593-199.65Zm-7.242,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.36,1.36,0,0,1,1.36,1.356A1.359,1.359,0,0,1,1468.35-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.36,1.36,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1461.11-199.65Zm-7.239,0h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1453.872-199.65Zm-7.238,0h-1.205a1.358,1.358,0,0,1-1.36-1.358,1.359,1.359,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1446.634-199.65Zm-7.237,0h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.355,1.355,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1439.4-199.65Zm-7.24,0h-1.205a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.205a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1432.156-199.65Zm-7.24,0h-1.205a1.352,1.352,0,0,1-1.356-1.358,1.354,1.354,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.36,1.36,0,0,1,1424.917-199.65Zm-7.238,0h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1417.678-199.65Zm-7.239,0h-1.2a1.359,1.359,0,0,1-1.364-1.358,1.361,1.361,0,0,1,1.364-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,1410.44-199.65Zm-7.238,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.361,1.361,0,0,1,1.362,1.356A1.36,1.36,0,0,1,1403.2-199.65Zm-7.237,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1395.964-199.65Zm-7.238,0h-1.209a1.356,1.356,0,0,1-1.358-1.358,1.358,1.358,0,0,1,1.358-1.356h1.209a1.359,1.359,0,0,1,1.358,1.356A1.357,1.357,0,0,1,1388.726-199.65Zm-7.24,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1381.486-199.65Zm-7.24,0h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1374.247-199.65Zm-7.239,0h-1.2a1.355,1.355,0,0,1-1.359-1.358,1.356,1.356,0,0,1,1.359-1.356h1.2a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1367.008-199.65Zm-7.237,0h-1.2a1.359,1.359,0,0,1-1.365-1.358,1.36,1.36,0,0,1,1.365-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1359.771-199.65Zm-7.239,0h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.358,1.358,0,0,1,1.358,1.356A1.356,1.356,0,0,1,1352.533-199.65Zm-7.237,0h-1.211a1.355,1.355,0,0,1-1.358-1.358,1.357,1.357,0,0,1,1.358-1.356h1.211a1.359,1.359,0,0,1,1.356,1.356A1.358,1.358,0,0,1,1345.3-199.65Zm-7.241,0h-1.208a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.208a1.359,1.359,0,0,1,1.359,1.356A1.357,1.357,0,0,1,1338.055-199.65Zm-7.241,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.36,1.36,0,0,1,1.363,1.356A1.358,1.358,0,0,1,1330.813-199.65Zm-7.237,0h-1.2a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.2a1.358,1.358,0,0,1,1.36,1.356A1.357,1.357,0,0,1,1323.576-199.65Z",
    transform: "translate(-1321.012 202.364)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M1318.843-199.65h-1.212a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.212a1.356,1.356,0,0,1,1.356,1.356A1.354,1.354,0,0,1,1318.843-199.65Z",
    transform: "translate(464.455 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M1313.52-199.65h-1.208a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.208a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1313.52-199.65Z",
    transform: "translate(462.537 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M1308.2-199.65h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.362,1.362,0,0,1,1.363,1.356A1.36,1.36,0,0,1,1308.2-199.65Z",
    transform: "translate(460.62 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M1302.876-199.65h-1.2a1.358,1.358,0,0,1-1.362-1.358,1.359,1.359,0,0,1,1.362-1.356h1.2a1.359,1.359,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1302.876-199.65Z",
    transform: "translate(458.703 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M1297.556-199.65h-1.207a1.358,1.358,0,0,1-1.36-1.358,1.36,1.36,0,0,1,1.36-1.356h1.207a1.357,1.357,0,0,1,1.36,1.356A1.356,1.356,0,0,1,1297.556-199.65Z",
    transform: "translate(456.785 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M1292.236-199.65h-1.207a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.207a1.356,1.356,0,0,1,1.358,1.356A1.354,1.354,0,0,1,1292.236-199.65Z",
    transform: "translate(454.868 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M1286.912-199.65h-1.2a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1286.912-199.65Z",
    transform: "translate(452.951 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M1281.59-199.65h-1.205a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.205a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1281.59-199.65Z",
    transform: "translate(451.034 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M1276.271-199.65h-1.205a1.355,1.355,0,0,1-1.36-1.358,1.356,1.356,0,0,1,1.36-1.356h1.205a1.356,1.356,0,0,1,1.359,1.356A1.355,1.355,0,0,1,1276.271-199.65Z",
    transform: "translate(449.115 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M1270.95-199.65h-1.2a1.359,1.359,0,0,1-1.365-1.358,1.36,1.36,0,0,1,1.365-1.356h1.2a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1270.95-199.65Z",
    transform: "translate(447.197 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M1265.628-199.65h-1.207a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.207a1.36,1.36,0,0,1,1.362,1.356A1.359,1.359,0,0,1,1265.628-199.65Z",
    transform: "translate(445.28 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M1260.309-199.65H1259.1a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.208a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1260.309-199.65Z",
    transform: "translate(443.363 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M1254.989-199.65h-1.212a1.354,1.354,0,0,1-1.355-1.358,1.355,1.355,0,0,1,1.355-1.356h1.212a1.359,1.359,0,0,1,1.358,1.356A1.358,1.358,0,0,1,1254.989-199.65Z",
    transform: "translate(441.446 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M1249.666-199.65h-1.208a1.356,1.356,0,0,1-1.359-1.358,1.357,1.357,0,0,1,1.359-1.356h1.208a1.358,1.358,0,0,1,1.358,1.356A1.356,1.356,0,0,1,1249.666-199.65Z",
    transform: "translate(439.528 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M1244.34-199.65h-1.2a1.353,1.353,0,0,1-1.356-1.358,1.355,1.355,0,0,1,1.356-1.356h1.2a1.361,1.361,0,0,1,1.365,1.356A1.359,1.359,0,0,1,1244.34-199.65Z",
    transform: "translate(437.611 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M1239.023-199.65h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.359,1.356A1.356,1.356,0,0,1,1239.023-199.65Z",
    transform: "translate(435.693 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M1233.7-199.65h-1.2a1.358,1.358,0,0,1-1.363-1.358,1.36,1.36,0,0,1,1.363-1.356h1.2a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1233.7-199.65Z",
    transform: "translate(433.775 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M1228.381-199.65h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.358,1.356A1.355,1.355,0,0,1,1228.381-199.65Z",
    transform: "translate(431.858 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M1223.061-199.65h-1.211a1.355,1.355,0,0,1-1.356-1.358,1.357,1.357,0,0,1,1.356-1.356h1.211a1.359,1.359,0,0,1,1.358,1.356A1.357,1.357,0,0,1,1223.061-199.65Z",
    transform: "translate(429.941 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M1217.738-199.65h-1.209a1.352,1.352,0,0,1-1.355-1.358,1.354,1.354,0,0,1,1.355-1.356h1.209a1.36,1.36,0,0,1,1.36,1.356A1.358,1.358,0,0,1,1217.738-199.65Z",
    transform: "translate(428.024 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M1212.415-199.65h-1.2a1.357,1.357,0,0,1-1.36-1.358,1.358,1.358,0,0,1,1.36-1.356h1.2a1.361,1.361,0,0,1,1.363,1.356A1.359,1.359,0,0,1,1212.415-199.65Z",
    transform: "translate(426.106 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M1207.1-199.65h-1.205a1.356,1.356,0,0,1-1.36-1.358,1.357,1.357,0,0,1,1.36-1.356h1.205a1.357,1.357,0,0,1,1.359,1.356A1.356,1.356,0,0,1,1207.1-199.65Z",
    transform: "translate(424.188 83.169)",
    fill: "#113047"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(431.95 -126.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M1678.708-204.968H326.077a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3H1678.708a1.3,1.3,0,0,1,1.295,1.3A1.3,1.3,0,0,1,1678.708-204.968Z",
    transform: "translate(-324.779 207.564)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(1586.105 -161.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M1224.319-233.444H1176.3a3.094,3.094,0,0,0-3.094,3.095V-203a3.1,3.1,0,0,0,3.094,3.093h48.02a3.094,3.094,0,0,0,3.093-3.093v-27.35A3.093,3.093,0,0,0,1224.319-233.444Z",
    transform: "translate(-1173.205 233.444)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(1591.446 -172.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M1194.441-241.89h-16.263a1.049,1.049,0,0,0-1.047,1.047v9.263a1.049,1.049,0,0,0,1.047,1.049h16.263a1.048,1.048,0,0,0,1.049-1.049v-9.263A1.048,1.048,0,0,0,1194.441-241.89Z",
    transform: "translate(-1177.131 241.89)",
    fill: "#2a73ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    transform: "translate(1593.827 -157.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M1186.5-230.617h-7.154a.462.462,0,0,0-.461.461v4.074a.461.461,0,0,0,.461.461h7.154a.459.459,0,0,0,.46-.461v-4.074A.46.46,0,0,0,1186.5-230.617Z",
    transform: "translate(-1178.881 230.617)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(14.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M1197.371-230.617h-7.154a.462.462,0,0,0-.461.461v4.074a.461.461,0,0,0,.461.461h7.154a.46.46,0,0,0,.46-.461v-4.074A.46.46,0,0,0,1197.371-230.617Z",
    transform: "translate(-1189.756 230.617)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(29.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M1208.246-230.617h-7.154a.461.461,0,0,0-.461.461v4.074a.461.461,0,0,0,.461.461h7.154a.46.46,0,0,0,.46-.461v-4.074A.46.46,0,0,0,1208.246-230.617Z",
    transform: "translate(-1200.631 230.617)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(1595.475 -179.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M1187.707-246.826h-7.153a.462.462,0,0,0-.461.461v4.074a.461.461,0,0,0,.461.461h7.153a.46.46,0,0,0,.461-.461v-4.074A.461.461,0,0,0,1187.707-246.826Z",
    transform: "translate(-1180.093 246.826)",
    fill: "#2991d1",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    transform: "translate(1624.715 -228.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M1201.587-251.748a31.3,31.3,0,0,0,31.295,31.3,31.3,31.3,0,0,0,31.3-31.3,31.3,31.3,0,0,0-31.3-31.295A31.294,31.294,0,0,0,1201.587-251.748Z",
    transform: "translate(-1201.587 283.043)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M1215.921-256.913a11.8,11.8,0,0,0,11.8,11.8,11.8,11.8,0,0,0,11.8-11.8,11.8,11.8,0,0,0-11.8-11.8A11.8,11.8,0,0,0,1215.921-256.913Z",
    transform: "translate(-1196.422 288.208)",
    fill: "#103048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(1603.517 -220.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    transform: "translate(12.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M1205.244-277.031A31.217,31.217,0,0,0,1194.92-253.8a31.2,31.2,0,0,0,9.163,22.13",
    transform: "translate(-1194.92 277.031)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(6.007 7.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M1194.9-271.572a31.164,31.164,0,0,0-4.478,16.142,31.187,31.187,0,0,0,3.141,13.686",
    transform: "translate(-1190.42 271.572)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(0 13.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M1187.587-266.95A31.231,31.231,0,0,0,1186-257.1a31.4,31.4,0,0,0,1.023,7.969",
    transform: "translate(-1186.004 266.95)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 13.611,
    cy: 13.611,
    r: 13.611,
    transform: "translate(1696.587 -248.332)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M1260.254-285.784a5.676,5.676,0,0,0,5.675,5.675,5.677,5.677,0,0,0,5.677-5.675,5.677,5.677,0,0,0-5.677-5.675A5.676,5.676,0,0,0,1260.254-285.784Z",
    transform: "translate(444.268 51.064)",
    fill: "#2d924b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 9.985,
    cy: 9.985,
    r: 9.985,
    transform: "translate(1669.508 -270.78) rotate(-67.393)",
    fill: "#48b185"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(1655.051 -356.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303",
    transform: "translate(53.494 177.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M1263.66-243.857l6.105.193c.251,0,.453-.605.456-1.359s-.2-1.36-.448-1.362l-6.107-.193c-.25,0-.452.608-.456,1.359S1263.408-243.859,1263.66-243.857Z",
    transform: "translate(-1263.211 246.578)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M1224.336-374.044l54.754.193c.25,0,.453-.607.456-1.36s-.2-1.36-.448-1.36l-54.755-.193c-.25,0-.452.607-.456,1.359S1224.084-374.046,1224.336-374.044Z",
    transform: "translate(-1223.887 376.765)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(53.494 188.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M1263.66-235.357l6.105.193c.251,0,.453-.605.456-1.359s-.2-1.36-.448-1.362l-6.107-.193c-.25,0-.452.608-.456,1.359S1263.408-235.359,1263.66-235.357Z",
    transform: "translate(-1263.211 238.078)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M1267.644-223.724c-.332.332,3.5,9.627,7.817,9.627h0a7.816,7.816,0,0,0,7.815-7.818v-28.35a7.815,7.815,0,0,0-7.815-7.817h0c-4.318,0-7.817,8.965-7.817,9.627Z",
    transform: "translate(-1208.126 419.533)",
    fill: "none",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(1640.962 -341.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(9.97 17.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M1225.326-352.851l-4.157-.132c-.171,0-.309.412-.31.925s.136.926.3.926l4.158.132c.169,0,.306-.414.309-.926S1225.5-352.851,1225.326-352.851Z",
    transform: "translate(-1220.859 352.983)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(9.97 9.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M1225.326-358.638l-4.157-.132c-.171,0-.309.414-.31.926s.136.925.3.926l4.158.131c.169,0,.306-.414.309-.925S1225.5-358.637,1225.326-358.638Z",
    transform: "translate(-1220.859 358.77)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M1224.172-359.151c.227-.226-2.382-6.554-5.322-6.554h0a5.32,5.32,0,0,0-5.32,5.322v19.3a5.32,5.32,0,0,0,5.32,5.32h0c2.94,0,5.322-6.1,5.322-6.553Z",
    transform: "translate(-1213.53 365.705)",
    fill: "none",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 8.171,
    cy: 8.171,
    r: 8.171,
    transform: "translate(1648.093 -362.325)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M1235.676-389.179a8.615,8.615,0,0,1-8.615,8.615h0a8.614,8.614,0,0,1-8.615-8.615v-35.369a8.615,8.615,0,0,1,8.615-8.616h0a8.615,8.615,0,0,1,8.615,8.616Z",
    transform: "translate(429.203)",
    fill: "#103048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M1274.677-355.217c0,3.978-3.857,7.2-8.615,7.2h0c-4.759,0-8.615-3.225-8.615-7.2v-29.577c0-3.978,3.856-7.2,8.615-7.2h0c4.759,0,8.615,3.227,8.615,7.2Z",
    transform: "translate(443.257 14.834)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(1735.845 -192.101)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_390",
    "data-name": "Line 390",
    y1: 7.652,
    x2: 7.652,
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_391",
    "data-name": "Line 391",
    x1: 7.652,
    y1: 7.652,
    transform: "translate(0 29.248)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_392",
    "data-name": "Line 392",
    x1: 10.822,
    y1: 0.005,
    transform: "translate(0.456 18.787)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    transform: "translate(1630.557 -339.95)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    "data-name": "Line 393",
    x1: 5.209,
    y2: 5.209,
    transform: "translate(2.468 19.911)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    "data-name": "Line 394",
    x2: 5.209,
    y2: 5.209,
    transform: "translate(2.468)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    "data-name": "Line 395",
    x2: 7.368,
    y2: 0.004,
    transform: "translate(0 12.327)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(1605.235 -144.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M1192.952-209.238a5.692,5.692,0,0,1-5.685-5.685,5.691,5.691,0,0,1,5.685-5.685,5.689,5.689,0,0,1,5.685,5.685A5.69,5.69,0,0,1,1192.952-209.238Zm0-8.649a2.966,2.966,0,0,0-2.967,2.964,2.971,2.971,0,0,0,2.967,2.964,2.972,2.972,0,0,0,2.968-2.964A2.968,2.968,0,0,0,1192.952-217.887Z",
    transform: "translate(-1187.267 220.608)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M1213.029-223.9s14.232,2.041,15.587-6.972",
    transform: "translate(427.251 72.898)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M1213.029-217.9s14.232,2.041,15.587-6.972",
    transform: "translate(427.251 75.06)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 68.923,
    transform: "translate(1648.329 -128.041)",
    fill: "#2a73ba",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(64.614 -110.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M1596.395-196.033s1.148,45.415-46.464,45.415l-.467.042H54.779",
    transform: "translate(-54.737 196.033)",
    fill: "none",
    stroke: "#103048",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M1600.816-196.033s0,49.326-48.122,49.326l-1.19.042H54.779",
    transform: "translate(-54.737 196.033)",
    fill: "none",
    stroke: "#364b99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M1604.908-196.033s-.254,53.2-48.377,53.2H1549.7l-1.589.015H54.748",
    transform: "translate(-54.748 196.033)",
    fill: "none",
    stroke: "#2972b9",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M1609.5-196.033s-1.02,57.022-49.567,57.022l-2.068.1H54.748",
    transform: "translate(-54.748 196.033)",
    fill: "none",
    stroke: "#48b185",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(1606.002 -109.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M1197.457-194.951s-1.148,45.415,46.464,45.415l.467.042h459.941",
    transform: "translate(-1184.364 194.951)",
    fill: "none",
    stroke: "#48b185",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M1194.206-194.951s0,49.326,48.122,49.326l1.19.042H1705.5",
    transform: "translate(-1185.534 194.951)",
    fill: "none",
    stroke: "#2972b9",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M1191.206-194.951s.256,53.2,48.378,53.2h6.827l1.589.015h458.621",
    transform: "translate(-1186.615 194.951)",
    fill: "none",
    stroke: "#364b99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M1187.831-194.951s1.02,57.022,49.568,57.022l2.066.1h468.372",
    transform: "translate(-1187.831 194.951)",
    fill: "none",
    stroke: "#103048",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(431.95 -111.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M1678.708-194.3H326.077a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3H1678.708a1.3,1.3,0,0,1,1.295,1.3A1.3,1.3,0,0,1,1678.708-194.3Z",
    transform: "translate(-324.779 196.898)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(62.615 -126.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M1407.209-204.968H54.577a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3H1407.209a1.3,1.3,0,0,1,1.295,1.3A1.3,1.3,0,0,1,1407.209-204.968Z",
    transform: "translate(-53.279 207.564)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    transform: "translate(62.615 -111.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M1407.209-194.3H54.577a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3H1407.209a1.3,1.3,0,0,1,1.295,1.3A1.3,1.3,0,0,1,1407.209-194.3Z",
    transform: "translate(-53.279 196.898)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    transform: "translate(754.377 -126.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M1915.725-204.968H563.095a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3h1352.63a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,1915.725-204.968Z",
    transform: "translate(-561.797 207.564)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(754.377 -111.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M1915.725-194.3H563.095a1.3,1.3,0,0,1-1.3-1.292,1.3,1.3,0,0,1,1.3-1.3h1352.63a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,1915.725-194.3Z",
    transform: "translate(-561.797 196.898)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(1691.918 -425.051)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    y2: 3.512,
    transform: "translate(7.256)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    "data-name": "Line 398",
    x1: 3.514,
    transform: "translate(11.125 8.218)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_399",
    "data-name": "Line 399",
    y1: 3.515,
    transform: "translate(7.426 12.469)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    "data-name": "Line 400",
    x2: 3.514,
    transform: "translate(0 7.935)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(1526.502 -164.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326",
    transform: "translate(17.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M1142.389-219.332c0,8.946,4.307,16.2,9.615,16.2s9.612-7.255,9.612-16.2-4.305-16.2-9.612-16.2S1142.389-228.278,1142.389-219.332Z",
    transform: "translate(-1142.389 235.531)",
    fill: "#103048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M1147.647-222.113a9.218,9.218,0,0,0,1.391-4.922c0-4.692-3.375-8.5-7.542-8.5s-7.542,3.8-7.542,8.5a9.216,9.216,0,0,0,1.394,4.922c-3.567,1.773-5.96,5.041-5.96,8.784,0,5.63,5.422,10.2,12.107,10.2s12.11-4.567,12.11-10.2C1153.607-217.071,1151.214-220.34,1147.647-222.113Z",
    transform: "translate(-1129.39 235.531)",
    fill: "#48b185"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    "data-name": "Line 401",
    y2: 17.262,
    transform: "translate(11.958 21.378)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    y2: 17.262,
    transform: "translate(26.344 21.378)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M1049.975-205.455a7.73,7.73,0,0,0,3.3-4.946v4.122Z",
    transform: "translate(368.494 80.273)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M1297.419-205.455a7.734,7.734,0,0,0,3.3-4.946v4.122Z",
    transform: "translate(457.661 80.273)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M853.533-205.455a7.734,7.734,0,0,0,3.3-4.946v4.122Z",
    transform: "translate(297.707 80.273)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(979.058 -156.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(3.194 14.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M903.757-219.575H731.007a1.7,1.7,0,0,0-1.7,1.7,1.7,1.7,0,0,0,1.7,1.7H903.757a1.7,1.7,0,0,0,1.7-1.7A1.7,1.7,0,0,0,903.757-219.575Z",
    transform: "translate(-729.309 219.575)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    transform: "translate(3.194 7.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M731.007-224.133a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.913A1.7,1.7,0,0,0,731.007-224.133Z",
    transform: "translate(-729.309 224.133)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(0 0.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M732.041-229.52a5.087,5.087,0,0,0-5.08,5.081,5.086,5.086,0,0,0,5.08,5.081,5.086,5.086,0,0,0,5.082-5.081A5.087,5.087,0,0,0,732.041-229.52Zm0,6.765a1.685,1.685,0,0,1-1.683-1.684,1.686,1.686,0,0,1,1.683-1.684,1.687,1.687,0,0,1,1.686,1.684A1.686,1.686,0,0,1,732.041-222.755Z",
    transform: "translate(-726.961 229.52)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(27.993 7.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M749.237-224.2a1.7,1.7,0,0,0-1.7,1.7v19.915a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.5A1.7,1.7,0,0,0,749.237-224.2Z",
    transform: "translate(-747.539 224.203)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(24.799 0.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M750.272-229.588a5.085,5.085,0,0,0-5.081,5.078,5.086,5.086,0,0,0,5.081,5.081,5.087,5.087,0,0,0,5.081-5.081A5.086,5.086,0,0,0,750.272-229.588Zm0,6.764a1.688,1.688,0,0,1-1.684-1.685,1.685,1.685,0,0,1,1.684-1.681,1.684,1.684,0,0,1,1.684,1.681A1.687,1.687,0,0,1,750.272-222.824Z",
    transform: "translate(-745.191 229.588)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335",
    transform: "translate(52.795 7.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M767.469-224.271a1.7,1.7,0,0,0-1.7,1.7v19.916a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.916A1.7,1.7,0,0,0,767.469-224.271Z",
    transform: "translate(-765.771 224.271)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(49.601 0.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M768.5-229.658a5.086,5.086,0,0,0-5.078,5.082A5.085,5.085,0,0,0,768.5-219.5a5.086,5.086,0,0,0,5.082-5.078A5.088,5.088,0,0,0,768.5-229.658Zm0,6.765a1.685,1.685,0,0,1-1.681-1.683,1.685,1.685,0,0,1,1.681-1.684,1.684,1.684,0,0,1,1.684,1.684A1.685,1.685,0,0,1,768.5-222.893Z",
    transform: "translate(-763.423 229.658)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    transform: "translate(77.596 7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M785.7-224.339a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.64A1.7,1.7,0,0,0,785.7-224.339Z",
    transform: "translate(-784.002 224.339)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338",
    transform: "translate(74.4 0.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M786.733-229.727a5.087,5.087,0,0,0-5.08,5.081,5.086,5.086,0,0,0,5.08,5.081,5.089,5.089,0,0,0,5.082-5.081A5.09,5.09,0,0,0,786.733-229.727Zm0,6.765a1.685,1.685,0,0,1-1.681-1.684,1.685,1.685,0,0,1,1.681-1.684,1.685,1.685,0,0,1,1.684,1.684A1.685,1.685,0,0,1,786.733-222.962Z",
    transform: "translate(-781.653 229.727)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339",
    transform: "translate(102.395 7.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M803.93-224.408a1.7,1.7,0,0,0-1.7,1.7v19.917a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.71A1.7,1.7,0,0,0,803.93-224.408Z",
    transform: "translate(-802.232 224.408)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    transform: "translate(99.202 0.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M804.963-229.794a5.082,5.082,0,0,0-5.078,5.078,5.084,5.084,0,0,0,5.078,5.081,5.087,5.087,0,0,0,5.081-5.081A5.084,5.084,0,0,0,804.963-229.794Zm0,6.761a1.682,1.682,0,0,1-1.681-1.683,1.682,1.682,0,0,1,1.681-1.681,1.683,1.683,0,0,1,1.683,1.681A1.683,1.683,0,0,1,804.963-223.033Z",
    transform: "translate(-799.885 229.794)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    transform: "translate(127.195 7.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M822.162-224.478a1.7,1.7,0,0,0-1.7,1.7v19.917a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.917A1.7,1.7,0,0,0,822.162-224.478Z",
    transform: "translate(-820.463 224.478)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342",
    transform: "translate(124.001 0.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M823.2-229.865a5.089,5.089,0,0,0-5.081,5.082,5.086,5.086,0,0,0,5.081,5.08,5.085,5.085,0,0,0,5.08-5.08A5.088,5.088,0,0,0,823.2-229.865Zm0,6.765a1.685,1.685,0,0,1-1.685-1.683,1.686,1.686,0,0,1,1.685-1.684,1.685,1.685,0,0,1,1.682,1.684A1.685,1.685,0,0,1,823.2-223.1Z",
    transform: "translate(-818.115 229.865)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    transform: "translate(151.995 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M840.391-224.545a1.7,1.7,0,0,0-1.7,1.7v19.916a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.916A1.7,1.7,0,0,0,840.391-224.545Z",
    transform: "translate(-838.693 224.545)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344",
    transform: "translate(148.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M841.426-229.933a5.086,5.086,0,0,0-5.08,5.081,5.086,5.086,0,0,0,5.08,5.081,5.085,5.085,0,0,0,5.079-5.081A5.085,5.085,0,0,0,841.426-229.933Zm0,6.765a1.685,1.685,0,0,1-1.684-1.684,1.685,1.685,0,0,1,1.684-1.684,1.684,1.684,0,0,1,1.681,1.684A1.684,1.684,0,0,1,841.426-223.168Z",
    transform: "translate(-836.346 229.933)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(166.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(3.193 14.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M1026.519-219.575H853.766a1.7,1.7,0,0,0-1.7,1.7,1.7,1.7,0,0,0,1.7,1.7h172.753a1.7,1.7,0,0,0,1.7-1.7A1.7,1.7,0,0,0,1026.519-219.575Z",
    transform: "translate(-852.068 219.575)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    transform: "translate(3.193 7.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M853.766-224.133a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.913A1.7,1.7,0,0,0,853.766-224.133Z",
    transform: "translate(-852.068 224.133)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(0 0.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M854.8-229.52a5.086,5.086,0,0,0-5.079,5.081,5.085,5.085,0,0,0,5.079,5.081,5.085,5.085,0,0,0,5.081-5.081A5.086,5.086,0,0,0,854.8-229.52Zm0,6.765a1.684,1.684,0,0,1-1.683-1.684,1.685,1.685,0,0,1,1.683-1.684,1.685,1.685,0,0,1,1.684,1.684A1.685,1.685,0,0,1,854.8-222.755Z",
    transform: "translate(-849.721 229.52)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    transform: "translate(27.993 7.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M872-224.2a1.7,1.7,0,0,0-1.7,1.7v19.915a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.5A1.7,1.7,0,0,0,872-224.2Z",
    transform: "translate(-870.299 224.203)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350",
    transform: "translate(24.799 0.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M873.031-229.588a5.085,5.085,0,0,0-5.08,5.078,5.086,5.086,0,0,0,5.08,5.081,5.087,5.087,0,0,0,5.082-5.081A5.086,5.086,0,0,0,873.031-229.588Zm0,6.764a1.687,1.687,0,0,1-1.683-1.685,1.685,1.685,0,0,1,1.683-1.681,1.684,1.684,0,0,1,1.685,1.681A1.687,1.687,0,0,1,873.031-222.824Z",
    transform: "translate(-867.951 229.588)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351",
    transform: "translate(52.795 7.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M890.229-224.271a1.7,1.7,0,0,0-1.7,1.7v19.916a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.916A1.7,1.7,0,0,0,890.229-224.271Z",
    transform: "translate(-888.531 224.271)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    transform: "translate(49.602 0.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M891.262-229.658a5.085,5.085,0,0,0-5.078,5.082,5.083,5.083,0,0,0,5.078,5.078,5.084,5.084,0,0,0,5.08-5.078A5.086,5.086,0,0,0,891.262-229.658Zm0,6.765a1.685,1.685,0,0,1-1.683-1.683,1.684,1.684,0,0,1,1.683-1.684,1.684,1.684,0,0,1,1.683,1.684A1.685,1.685,0,0,1,891.262-222.893Z",
    transform: "translate(-886.184 229.658)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353",
    transform: "translate(77.596 7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M908.46-224.339a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.64A1.7,1.7,0,0,0,908.46-224.339Z",
    transform: "translate(-906.762 224.339)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354",
    transform: "translate(74.4 0.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M909.491-229.727a5.087,5.087,0,0,0-5.078,5.081,5.086,5.086,0,0,0,5.078,5.081,5.089,5.089,0,0,0,5.084-5.081A5.09,5.09,0,0,0,909.491-229.727Zm0,6.765a1.685,1.685,0,0,1-1.68-1.684,1.685,1.685,0,0,1,1.68-1.684,1.686,1.686,0,0,1,1.686,1.684A1.686,1.686,0,0,1,909.491-222.962Z",
    transform: "translate(-904.413 229.727)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355",
    transform: "translate(102.395 7.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M926.69-224.408a1.7,1.7,0,0,0-1.7,1.7v19.917a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.71A1.7,1.7,0,0,0,926.69-224.408Z",
    transform: "translate(-924.992 224.408)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356",
    transform: "translate(99.201 0.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M927.724-229.794a5.082,5.082,0,0,0-5.079,5.078,5.085,5.085,0,0,0,5.079,5.081,5.087,5.087,0,0,0,5.081-5.081A5.085,5.085,0,0,0,927.724-229.794Zm0,6.761a1.683,1.683,0,0,1-1.681-1.683,1.682,1.682,0,0,1,1.681-1.681,1.684,1.684,0,0,1,1.683,1.681A1.684,1.684,0,0,1,927.724-223.033Z",
    transform: "translate(-922.644 229.794)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357",
    transform: "translate(127.195 7.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M944.922-224.478a1.7,1.7,0,0,0-1.7,1.7v19.917a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.917A1.7,1.7,0,0,0,944.922-224.478Z",
    transform: "translate(-943.223 224.478)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(124.001 0.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M945.954-229.865a5.088,5.088,0,0,0-5.079,5.082,5.086,5.086,0,0,0,5.079,5.08,5.085,5.085,0,0,0,5.081-5.08A5.088,5.088,0,0,0,945.954-229.865Zm0,6.765a1.684,1.684,0,0,1-1.683-1.683,1.684,1.684,0,0,1,1.683-1.684,1.685,1.685,0,0,1,1.683,1.684A1.685,1.685,0,0,1,945.954-223.1Z",
    transform: "translate(-940.875 229.865)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359",
    transform: "translate(151.995 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M963.151-224.545a1.7,1.7,0,0,0-1.7,1.7v19.916a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.916A1.7,1.7,0,0,0,963.151-224.545Z",
    transform: "translate(-961.453 224.545)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360",
    transform: "translate(148.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M964.186-229.933a5.088,5.088,0,0,0-5.081,5.081,5.088,5.088,0,0,0,5.081,5.081,5.086,5.086,0,0,0,5.079-5.081A5.086,5.086,0,0,0,964.186-229.933Zm0,6.765a1.686,1.686,0,0,1-1.684-1.684,1.686,1.686,0,0,1,1.684-1.684,1.686,1.686,0,0,1,1.683,1.684A1.686,1.686,0,0,1,964.186-223.168Z",
    transform: "translate(-959.105 229.933)",
    fill: "#113047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(333.991 0.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    transform: "translate(3.194 13.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M1068.1-219.575H976.527a1.7,1.7,0,0,0-1.7,1.7,1.7,1.7,0,0,0,1.7,1.7H1068.1a1.7,1.7,0,0,0,1.7-1.7A1.7,1.7,0,0,0,1068.1-219.575Z",
    transform: "translate(-974.828 219.575)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363",
    transform: "translate(3.194 7.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M976.527-224.133a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.913A1.7,1.7,0,0,0,976.527-224.133Z",
    transform: "translate(-974.828 224.133)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(0 0.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M977.561-229.52a5.088,5.088,0,0,0-5.081,5.081,5.087,5.087,0,0,0,5.081,5.081,5.087,5.087,0,0,0,5.082-5.081A5.088,5.088,0,0,0,977.561-229.52Zm0,6.765a1.685,1.685,0,0,1-1.683-1.684,1.686,1.686,0,0,1,1.683-1.684,1.686,1.686,0,0,1,1.684,1.684A1.685,1.685,0,0,1,977.561-222.755Z",
    transform: "translate(-972.48 229.52)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(27.995 7.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M994.757-224.2a1.7,1.7,0,0,0-1.7,1.7v19.915a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.5A1.7,1.7,0,0,0,994.757-224.2Z",
    transform: "translate(-993.059 224.203)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366",
    transform: "translate(24.801 0.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M995.791-229.588a5.085,5.085,0,0,0-5.08,5.078,5.086,5.086,0,0,0,5.08,5.081,5.086,5.086,0,0,0,5.082-5.081A5.086,5.086,0,0,0,995.791-229.588Zm0,6.764a1.687,1.687,0,0,1-1.683-1.685,1.684,1.684,0,0,1,1.683-1.681,1.684,1.684,0,0,1,1.685,1.681A1.687,1.687,0,0,1,995.791-222.824Z",
    transform: "translate(-990.711 229.588)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(52.797 7.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M1012.989-224.271a1.7,1.7,0,0,0-1.7,1.7v19.916a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7v-19.916A1.7,1.7,0,0,0,1012.989-224.271Z",
    transform: "translate(-1011.291 224.271)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368",
    transform: "translate(49.602 0.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M1014.023-229.658a5.086,5.086,0,0,0-5.08,5.082,5.084,5.084,0,0,0,5.08,5.078,5.085,5.085,0,0,0,5.079-5.078A5.087,5.087,0,0,0,1014.023-229.658Zm0,6.765a1.685,1.685,0,0,1-1.683-1.683,1.684,1.684,0,0,1,1.683-1.684,1.685,1.685,0,0,1,1.683,1.684A1.686,1.686,0,0,1,1014.023-222.893Z",
    transform: "translate(-1008.943 229.658)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(77.597 7.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M1031.22-224.339a1.7,1.7,0,0,0-1.7,1.7v19.913a1.7,1.7,0,0,0,1.7,1.7,1.7,1.7,0,0,0,1.7-1.7V-222.64A1.7,1.7,0,0,0,1031.22-224.339Z",
    transform: "translate(-1029.522 224.339)",
    fill: "#113047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(74.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M1032.252-229.727a5.087,5.087,0,0,0-5.079,5.081,5.086,5.086,0,0,0,5.079,5.081,5.089,5.089,0,0,0,5.082-5.081A5.09,5.09,0,0,0,1032.252-229.727Zm0,6.765a1.685,1.685,0,0,1-1.681-1.684,1.685,1.685,0,0,1,1.681-1.684,1.685,1.685,0,0,1,1.684,1.684A1.685,1.685,0,0,1,1032.252-222.962Z",
    transform: "translate(-1027.173 229.727)",
    fill: "#113047"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    transform: "translate(1193.592 -177.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M947.509-203.889a9.01,9.01,0,0,0,9.008,9.01,9.009,9.009,0,0,0,9.01-9.01,9.009,9.009,0,0,0-9.01-9.008A9.01,9.01,0,0,0,947.509-203.889Z",
    transform: "translate(-862.021 257.054)",
    fill: "#103048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M902.064-203.889a9.009,9.009,0,0,0,9.008,9.01,9.009,9.009,0,0,0,9.01-9.01,9.009,9.009,0,0,0-9.01-9.008A9.009,9.009,0,0,0,902.064-203.889Z",
    transform: "translate(-878.397 257.054)",
    fill: "#103048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M931.721-192.239h32.352s.824-15.455,14.837-15.455c13.187,0,14.631,12.983,14.631,14.837h17.1v-16.691a6.042,6.042,0,0,0-4.533-6.181c-15.455-4.534-31.529-9.068-31.529-9.068l-18.342-15.248s-1.441-1.855-4.945-1.649-47.808,0-47.808,0-3.915-.826-4.945,2.266c-.782,2.345-11.747,39.566-11.747,39.566s-3.091,6.387,2.473,6.387h12.983s1.442-14.013,14.836-14.013S931.721-192.239,931.721-192.239Z",
    transform: "translate(-884.207 246.641)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    x1: 48.015,
    transform: "translate(18.664)",
    fill: "#2991d1",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    x1: 80.162,
    transform: "translate(10.832 22.462)",
    fill: "#2991d1",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M930.5-240.964l7.83,16.28v31.117",
    transform: "translate(-868.15 246.94)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    "data-name": "Line 405",
    y2: 36.474,
    transform: "translate(43.805 5.77)",
    fill: "#2991d1",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    x1: 6.209,
    y2: 19.364,
    transform: "translate(0 15.562)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(1078.943 -175.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(22.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M817.22-222.67c0,11.582,5.576,20.975,12.45,20.975s12.444-9.393,12.444-20.975-5.573-20.975-12.444-20.975S817.22-234.255,817.22-222.67Z",
    transform: "translate(-817.22 243.645)",
    fill: "#103048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M824.029-226.272a11.941,11.941,0,0,0,1.8-6.371c0-6.077-4.37-11-9.765-11s-9.767,4.926-9.767,11a11.944,11.944,0,0,0,1.807,6.371c-4.62,2.3-7.717,6.527-7.717,11.372,0,7.293,7.022,13.2,15.678,13.2s15.681-5.912,15.681-13.2C831.746-219.745,828.646-223.976,824.029-226.272Z",
    transform: "translate(-800.387 243.645)",
    fill: "#48b185"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    "data-name": "Line 407",
    y2: 22.353,
    transform: "translate(15.487 27.679)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_408",
    "data-name": "Line 408",
    y2: 22.353,
    transform: "translate(34.112 27.679)",
    fill: "none",
    stroke: "#113047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379",
    transform: "translate(1000.475 -162.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(0 11.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M773.937-225.444H744.594c-1.042,0-1.889,1.665-1.889,3.722v32.9c0,2.053.847,3.721,1.889,3.721h29.343c1.045,0,1.89-1.668,1.89-3.721v-32.9C775.827-223.779,774.982-225.444,773.937-225.444Z",
    transform: "translate(-742.705 225.444)",
    fill: "#2873ba",
    stroke: "#113047",
    strokeMiterlimit: 10,
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2378",
    "data-name": "Group 2378",
    transform: "translate(4.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M768.649-233.9H747.269c-.759,0-1.377.456-1.377,1.019v9.018c0,.562.618,1.019,1.377,1.019h21.381c.762,0,1.378-.457,1.378-1.019v-9.018C770.027-233.448,769.411-233.9,768.649-233.9Z",
    transform: "translate(-745.892 233.904)",
    fill: "#2a73ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380",
    transform: "translate(1009.712 -144.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M755.181-209.238a5.692,5.692,0,0,1-5.686-5.685,5.691,5.691,0,0,1,5.686-5.685,5.689,5.689,0,0,1,5.684,5.685A5.69,5.69,0,0,1,755.181-209.238Zm0-8.649a2.968,2.968,0,0,0-2.968,2.964,2.972,2.972,0,0,0,2.968,2.964,2.971,2.971,0,0,0,2.967-2.964A2.966,2.966,0,0,0,755.181-217.887Z",
    transform: "translate(-749.495 220.608)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenstra17);
export default __webpack_public_path__ + "static/media/senstra_17.076ba13e2ad94c202f6767be37764241.svg";
export { ForwardRef as ReactComponent };